import { render, staticRenderFns } from "./PlatformAppleSpotifyDetail.vue?vue&type=template&id=22e37806&scoped=true"
import script from "./PlatformAppleSpotifyDetail.vue?vue&type=script&lang=js"
export * from "./PlatformAppleSpotifyDetail.vue?vue&type=script&lang=js"
import style0 from "./PlatformAppleSpotifyDetail.vue?vue&type=style&index=0&id=22e37806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e37806",
  null
  
)

export default component.exports